import { mapMutations } from "vuex";
import { app, firestore } from "../../lib/firebase";

export default {
  name: "Call",

  metaInfo: {
    title: "Llamar gratis"
  },

  components: {
    Overlay: () => import("../../components/Overlay")
  },

  data: () => ({
    clientId: null,
    project: null,

    call: null,
    phone: null,
    state: "LOADING",
    audio: null,
    busyAudio: null,

    seconds: 0,
    counterClear: null
  }),

  computed: {
    stateText() {
      switch (this.state) {
        case "CALLING":
          return "Llamando";
        case "ENDED":
          return "Llamada terminada";
        case "INCALL":
          return "En llamada";
        default:
          return "Conectando...";
      }
    },

    time() {
      const seconds = this.seconds;
      let secs = seconds % 60;
      let mins = Math.floor(seconds / 60);

      return `${mins < 10 ? `0${mins}` : mins}:${
        secs < 10 ? `0${secs}` : secs
      }`;
    }
  },

  methods: {
    async getProject() {
      this.project = await (await firestore())
        .collection("projects")
        .doc(this.clientId)
        .get()
        .then(doc => doc.data());
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    },

    async initAudio() {
      const { Howl } = await import("howler");

      this.audio = new Howl({
        loop: true,
        src: ["/ringing.mp3", "/ringing.wav"],
        volume: 0.4
      });

      this.busyAudio = new Howl({
        loop: true,
        src: ["/busy.mp3", "/busy.wav"]
      });
    },

    async initPhone() {
      if (this.phone) return;

      const VoxImplant = await import("voximplant-websdk");
      this.voximplant = VoxImplant.getInstance();

      if (!this.voximplant.alreadyInitialized) {
        await this.voximplant.init({
          micRequired: true,
          progressTone: true,
          progressToneCountry: "US"
        });
      }

      this.voximplant.addEventListener(
        VoxImplant.Events.ConnectionClosed,
        () => {
          this.clearState();
        }
      );

      if (!this.voximplant.connected()) {
        await this.voximplant.connect();
      }
      await this.voximplant.login(
        "fontumi@fontumiwebapp.fontumi.voximplant.com",
        "fontumi"
      );

      this.makeCall();
    },

    async makeCall() {
      if (this.voximplant) {
        try {
          const VoxImplant = await import("voximplant-websdk");

          this.seconds = 0;
          this.state = "CALLING";
          this.call = this.voximplant.call(
            `sip:int${this.project.phone}@sip.enruta.co`,
            false,
            `${this.project.sip.login}#${this.project.sip.password}`
          );

          this.audio.play();

          this.call.on(VoxImplant.CallEvents.Connected, event => {
            this.state = "INCALL";
            this.audio.stop();
            this.counterClear = setInterval(() => this.seconds++, 1000);
          });

          this.call.on(VoxImplant.CallEvents.Disconnected, event => {
            this.clearState();
          });

          this.call.on(VoxImplant.CallEvents.Failed, event => {
            this.clearState();
            this.setMessage({
              message: "Ha ocurrido un error. Inténtalo más tarde.",
              color: "error"
            });
          });
        } catch (e) {
          this.setMessage({
            message: "Ha ocurrido un error. Inténtalo más tarde.",
            color: "error"
          });
        }
      }
    },

    hangup() {
      if (this.call) {
        this.state = "ENDED";
        this.call.hangup();
      }
    },

    clearState() {
      this.hangup();
      if (this.counterClear) {
        clearInterval(this.counterClear);
      }
      this.audio.stop();
    },

    ...mapMutations(["setMessage"])
  },

  async beforeMount() {
    this.clientId = this.$route.query.clientId;

    try {
      this.initAudio();
      await this.getProject();

      if (this.project) {
        this.initPhone();
        return;
      }
    } catch (e) {
      console.error(e);
    }

    return this.$router.push("/");
  },

  mounted() {
    if (this.project) {
      document.title = `${this.project.name} - Llamar gratis con Fontumi`;
    }
  },

  beforeDestroy() {
    this.hangup();
    this.phone = null;
  }
};
